import { render, staticRenderFns } from "./transparencySetting.vue?vue&type=template&id=197cd1e6&scoped=true"
import script from "./transparencySetting.vue?vue&type=script&lang=js"
export * from "./transparencySetting.vue?vue&type=script&lang=js"
import style0 from "./transparencySetting.vue?vue&type=style&index=0&id=197cd1e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197cd1e6",
  null
  
)

export default component.exports